import { useState } from "react";
import { Asset, AssetManualMetrics } from "../models/asset";
import { fetchUptimeAssets } from "../api/fetchAssets";

function useUptimeAssets() {
    const [uptimeAssets, setUptimeAssets] = useState<AssetManualMetrics[]>([]);

    const getUptimeAssets = async (assetIds: string[]) => {
        if(assetIds?.length) {
            const data = await fetchUptimeAssets(assetIds);
            setUptimeAssets([...uptimeAssets, ...data]);
        }
    }

    const refreshUptimeAsset = async (assetId: string) => {
        if(assetId) {
            const data = await fetchUptimeAssets([assetId]);
            if(data?.length > 0) {
                setUptimeAssets(prev => {
                    const filtered = prev.filter(asset => asset.assetId !== assetId);
                    return [...filtered, ...data];
                });
            }
        }
    }

    return { uptimeAssets, getUptimeAssets, refreshUptimeAsset }
}

export default useUptimeAssets;